import { render } from "./ListActionsBlockComponent.vue?vue&type=template&id=edd0eac4&scoped=true"
import script from "./ListActionsBlockComponent.vue?vue&type=script&lang=js"
export * from "./ListActionsBlockComponent.vue?vue&type=script&lang=js"

import "./ListActionsBlockComponent.vue?vue&type=style&index=0&id=edd0eac4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edd0eac4"]])

export default __exports__